import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Backdrop, CircularProgress, Collapse, Divider, Drawer, Grid, IconButton, Toolbar, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '../../../../assets/customIcons';
import { MuiBox, MuiButton, MuiStack } from '../../../../components';
import { MuiCheckBox } from '../../../../components/atoms/checkBox';
import DrawerHeader from '../../../../components/atoms/DrawerHeader';
import { MuiIconButton } from '../../../../components/atoms/iconButtonComponent';
import Loader from '../../../../components/molecules/loader';
import { useAppSelector } from '../../../../store/hooks';
import { CrossIcon } from '../../../fieldFailureReports/assets/svg';
import { CommonPartLabourDetails } from './commonPartLabourDetails';
import { t } from 'i18next';
// import { CommonPartLabourDetailsWrapper } from './commonPartLabourDetailsWrapper';
var StandardJobsPartLabourDetailsDrawer = function (props) {
    var _jobItemDetails$Parts, _totals$decoratedTaxe;
    var open = props.open, onClose = props.onClose, jobItemDetails = props.jobItemDetails, SystemName = props.SystemName, showCheckbox = props.showCheckbox, isDisabled = props.isDisabled;
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var isLoaderOpen = useAppSelector(function (state) { return state.common.isLoader; }).isLoaderOpen;
    var _a = useState(jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.PartsLaboursList), partsLabourList = _a[0], setPartsLabourList = _a[1];
    var _b = useState(null), accordianIndex = _b[0], setAccordianIndex = _b[1];
    var _c = useState(false), openTaxes = _c[0], setOpenTaxes = _c[1];
    var _d = useState(false), openSummary = _d[0], setOpenSummary = _d[1];
    var _e = useState(false), shuffleTotal = _e[0], setShuffleTotal = _e[1];
    // const ReCallBatch: FC<ReCallBatchProps> = ({ item, index }) => {
    //         return (
    //             <MuiStack alignItems={'center'} sx={{ mt: 0 }}>
    //                 <Typography sx={{ fontSize: '12px', fontWeight: '400' }} variant='h4' color={'#6A7682'}>{`#${item?.PartCode || item?.LabourCode || item.SkuCode || item.Code}`}</Typography>
    //                 <Divider sx={{ mx: 1.5, my: 0.8 }} orientation="vertical" flexItem />
    //                 <Box key={index} sx={{ display: 'inline-flex', justifyContent: 'space-evenly', borderRadius: '6px', backgroundColor: '#FFF7E5', placeItems: 'center', padding: '2px 8px' }}>
    //                     <Typography color={'#CC7A00'} fontSize={'sm'} fontWeight={'medium'}>
    //                         Recall
    //                     </Typography>
    //                 </Box>
    //             </MuiStack>
    //         )
    //     }
    useEffect(function () {
        if (jobItemDetails !== null && jobItemDetails !== void 0 && jobItemDetails.PartsLaboursList) {
            setPartsLabourList(jobItemDetails.PartsLaboursList);
        }
    }, [jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.PartsLaboursList]);
    var handleCloseDrawer = function () {
        onClose(partsLabourList);
        setAccordianIndex(-1);
        setOpenSummary(false);
        setOpenTaxes(false);
    };
    var convertToFixed = function (value) {
        var toFixedNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        return value.toFixed(toFixedNumber);
    };
    var calculateSummary = function (allJobDetails) {
        var totalBaseAmount = 0;
        var totalDiscountAmount = 0;
        var totalTaxableAmount = 0;
        var totalTaxes = 0;
        var totalAmount = 0;
        var totalPartPrice = 0;
        var totalLabourPrice = 0;
        var decoratedTaxes = [];
        allJobDetails.forEach(function (job) {
            var _job$SelectedPriceDet, _job$SelectedPriceDet2, _job$SelectedPriceDet3, _job$SelectedPriceDet4, _job$SelectedPriceDet5, _job$SelectedPriceDet6;
            totalBaseAmount += (job === null || job === void 0 || (_job$SelectedPriceDet = job.SelectedPriceDetails) === null || _job$SelectedPriceDet === void 0 ? void 0 : _job$SelectedPriceDet.BaseAmount) || 0;
            totalAmount += (job === null || job === void 0 || (_job$SelectedPriceDet2 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet2 === void 0 ? void 0 : _job$SelectedPriceDet2.Amount) || 0;
            totalDiscountAmount += (job === null || job === void 0 || (_job$SelectedPriceDet3 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet3 === void 0 ? void 0 : _job$SelectedPriceDet3.discountAmount) || 0;
            totalTaxableAmount += (job === null || job === void 0 || (_job$SelectedPriceDet4 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet4 === void 0 ? void 0 : _job$SelectedPriceDet4.TaxableAmount) || 0;
            job === null || job === void 0 || (_job$SelectedPriceDet5 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet5 === void 0 || (_job$SelectedPriceDet5 = _job$SelectedPriceDet5.Taxes) === null || _job$SelectedPriceDet5 === void 0 || _job$SelectedPriceDet5.forEach(function (tax) {
                totalTaxes += tax.TaxComponentAmount || 0;
            });
            job === null || job === void 0 || (_job$SelectedPriceDet6 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet6 === void 0 || (_job$SelectedPriceDet6 = _job$SelectedPriceDet6.Taxes) === null || _job$SelectedPriceDet6 === void 0 || _job$SelectedPriceDet6.forEach(function (tax) {
                var taxType = decoratedTaxes.find(function (t) { return t.type === tax.TaxComponentName; });
                if (!taxType) {
                    taxType = {
                        type: tax.TaxComponentName,
                        rates: []
                    };
                    decoratedTaxes.push(taxType);
                }
                var existingRate = taxType.rates.find(function (r) { return r.rate === tax.TaxComponentPercentage; });
                if (existingRate) {
                    var _job$SelectedPriceDet7;
                    existingRate.amount += tax.TaxComponentAmount;
                    existingRate.taxableAmount += (job === null || job === void 0 || (_job$SelectedPriceDet7 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet7 === void 0 ? void 0 : _job$SelectedPriceDet7.TaxableAmount) || 0;
                }
                else {
                    var _job$SelectedPriceDet8;
                    taxType.rates.push({
                        rate: tax.TaxComponentPercentage,
                        amount: tax.TaxComponentAmount,
                        taxableAmount: (job === null || job === void 0 || (_job$SelectedPriceDet8 = job.SelectedPriceDetails) === null || _job$SelectedPriceDet8 === void 0 ? void 0 : _job$SelectedPriceDet8.TaxableAmount) || 0
                    });
                }
            });
        });
        var netPayableAmount = totalAmount + totalPartPrice + totalLabourPrice;
        totalBaseAmount += totalPartPrice + totalLabourPrice;
        return {
            totalBaseAmount: totalBaseAmount,
            totalDiscountAmount: totalDiscountAmount,
            totalTaxableAmount: totalTaxableAmount,
            discountPercentage: 0,
            totalTaxes: totalTaxes,
            netPayableAmount: netPayableAmount,
            decoratedTaxes: decoratedTaxes,
            Amount: totalAmount
        };
    };
    var useTotals = function (partsLabourList, shuffleTotal) {
        var _a = useState(function () { return calculateSummary(partsLabourList); }), totals = _a[0], setTotals = _a[1];
        useEffect(function () {
            setTotals(calculateSummary(partsLabourList));
        }, [shuffleTotal, partsLabourList]);
        return totals;
    };
    var totals = useTotals(partsLabourList, shuffleTotal);
    return /*#__PURE__*/ React.createElement(Drawer, {
        id: "translate-to-job-drawer-standard",
        anchor: isDesktop ? "right" : 'bottom',
        open: open,
        onClose: handleCloseDrawer,
        sx: {
            display: {
                xs: 'block',
                sm: 'block',
                md: 'block',
                lg: 'block'
            },
            '& .MuiDrawer-paper': {
                width: {
                    xs: '100%',
                    sm: '50%',
                    md: '450px',
                    lg: '450px',
                    xl: '450px'
                },
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px'
            }
        }
    }, isDesktop && /*#__PURE__*/ React.createElement(DrawerHeader, null), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        className: "border-bottom-custom",
        sx: {
            py: 3
        }
    }, /*#__PURE__*/ React.createElement(MuiBox, {
        sx: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            width: '100%'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 11,
        style: {
            display: 'flex',
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'xl',
            color: 'text.primary'
        },
        id: "trasnlateToJobItems",
        align: "left"
    }, "Job  details")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 1
    }, /*#__PURE__*/ React.createElement(MuiIconButton, {
        id: "closeIconBtn",
        onClick: handleCloseDrawer,
        disabled: isLoaderOpen,
        style: {
            marginLeft: "7px"
        }
    }, /*#__PURE__*/ React.createElement(CrossIcon, {
        id: "crossIcon",
        sx: {
            fontSize: 21
        }
    })))))), isLoaderOpen ? /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Loader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        padding: 2,
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        display: "flex",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(MuiStack, null, showCheckbox ? /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "standardServiceGroupName-checkbox",
        checkBoxValue: jobItemDetails.isChecked,
        label: /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'flex-start',
            alignItems: "flex-start"
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                textTransform: 'capitalize',
                fontSize: 'base',
                fontWeight: 'medium',
                color: 'text.primary'
            }
        }, jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.StandardServiceGroupName)),
        disabled: isDisabled
        // sx={{ opacity: isDisabled ? 0.7 : 1 }}
        // handleChange={() => handleCheckBoxClick(item)}
    }) : /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-start',
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            textTransform: 'capitalize',
            fontSize: 'base',
            fontWeight: 'medium',
            color: 'text.primary'
        }
    }, jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.StandardServiceGroupName)))), /*#__PURE__*/ React.createElement(MuiStack, {
        display: 'flex',
        justifyContent: 'space-between',
        mt: !showCheckbox ? 0.5 : -0.5,
        ml: showCheckbox ? 3.4 : 0
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: 'text.tertiary',
            mr: 0.5
        }
    }, "Part -"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: 'text.primary'
        }
    }, jobItemDetails !== null && jobItemDetails !== void 0 && jobItemDetails.PartsCount ? jobItemDetails === null || jobItemDetails === void 0 || (_jobItemDetails$Parts = jobItemDetails.PartsCount) === null || _jobItemDetails$Parts === void 0 ? void 0 : _jobItemDetails$Parts.toString().padStart(2, '0') : '00'), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            mx: 1.5,
            my: 0.5,
            bgcolor: 'secondary.50'
        },
        orientation: "vertical",
        flexItem: true
    }), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: 'text.tertiary',
            mr: 0.5
        }
    }, "Labour -"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: 'text.primary'
        }
    }, jobItemDetails !== null && jobItemDetails !== void 0 && jobItemDetails.LabourCount ? jobItemDetails === null || jobItemDetails === void 0 ? void 0 : jobItemDetails.LabourCount.toString().padStart(2, '0') : '00'))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%',
            marginTop: '12px'
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        p: 2.5,
        sx: {
            gap: '16px'
        }
    }, partsLabourList === null || partsLabourList === void 0 ? void 0 : partsLabourList.map(function (item, index) { /*#__PURE__*/ return React.createElement(CommonPartLabourDetails, {
        partsLabourList: partsLabourList,
        setPartsLabourList: setPartsLabourList,
        index: index,
        isAccordianRequired: true,
        SystemName: SystemName,
        accordianIndex: accordianIndex,
        setAccordianIndex: setAccordianIndex,
        jobItemDetails: item,
        key: index,
        setShuffleTotal: setShuffleTotal,
        isDisabled: isDisabled
    }); }))), /*#__PURE__*/ React.createElement(MuiStack, {
        p: 2
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%'
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        p: 2
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "Total Amount"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(convertToFixed((totals === null || totals === void 0 ? void 0 : totals.Amount) || 0))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'end'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        onClick: function () {
            if (openSummary) {
                setOpenTaxes(false);
            }
            setOpenSummary(!openSummary);
        },
        variant: "text",
        endIcon: openSummary ? /*#__PURE__*/ React.createElement(ChevronUpIcon, null) : /*#__PURE__*/ React.createElement(ChevronDownIcon, null),
        name: "See summary",
        size: "small",
        sx: {
            backgroundColor: 'transparent',
            pr: 0,
            fontWeight: "medium",
            fontSize: 'sm'
        },
        id: "add-again"
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Collapse, {
        in: openSummary,
        sx: {
            borderRadius: '8px',
            boxShadow: '0px 0px 16px 0px #00000014'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: '12px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        sx: {
            mt: 1
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        }
    }, t("Total base amount"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(convertToFixed((totals === null || totals === void 0 ? void 0 : totals.totalBaseAmount) || 0)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        }
    }, t("Total taxable amount"))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(convertToFixed((totals === null || totals === void 0 ? void 0 : totals.totalTaxableAmount) || 0)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            cursor: "pointer",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        onClick: function () { return setOpenTaxes(!openTaxes); }
    }, "Taxes"), /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        onClick: function () { return setOpenTaxes(!openTaxes); }
    }, openTaxes ? /*#__PURE__*/ React.createElement(ExpandLess, null) : /*#__PURE__*/ React.createElement(ExpandMore, null)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(convertToFixed((totals === null || totals === void 0 ? void 0 : totals.totalTaxes) || 0))))), openTaxes && /*#__PURE__*/ React.createElement(Collapse, {
        in: openTaxes,
        sx: {
            mt: 1,
            bgcolor: "secondary.50",
            p: 2,
            borderRadius: 2
        }
    }, totals !== null && totals !== void 0 && totals.decoratedTaxes && (totals === null || totals === void 0 || (_totals$decoratedTaxe = totals.decoratedTaxes) === null || _totals$decoratedTaxe === void 0 ? void 0 : _totals$decoratedTaxe.length) > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 10
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, "@")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, "On")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, t("Tax amount")))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        py: 1
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%',
            borderTop: '1.5px dashed #DEE4EB',
            borderBottom: 'none',
            borderLeft: 'none',
            borderRight: 'none'
        }
    }))), totals === null || totals === void 0 ? void 0 : totals.decoratedTaxes.map(function (tax, index) { /*#__PURE__*/ return React.createElement(Grid, {
        container: true,
        key: index,
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3',
        fontWeight: 'bold'
    }, tax.type, ":")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 2
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 10
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, tax.rates.map(function (rate, i) { /*#__PURE__*/ return React.createElement(React.Fragment, {
        key: i
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB',
            my: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3'
    }, rate.rate, " %")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "center",
        sx: {
            borderRight: '1.5px solid #DEE4EB',
            my: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: '#8593A3'
    }, "\u20B9 ", rate.taxableAmount.toFixed(2))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 4,
        textAlign: "right",
        sx: {
            my: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 'bold'
    }, "\u20B9 ", rate.amount.toFixed(2)))); }))), (totals === null || totals === void 0 ? void 0 : totals.decoratedTaxes.length) - 1 != index && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        py: 1
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%',
            borderTop: '1.5px dashed #DEE4EB',
            borderBottom: 'none',
            borderLeft: 'none',
            borderRight: 'none'
        }
    }))); })) : /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1
    }, /*#__PURE__*/ React.createElement(Typography, null, t("No data found")))))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%',
            marginTop: '12px'
        }
    })))), /*#__PURE__*/ React.createElement(Backdrop, {
        sx: function (theme) { return ({
            color: 'white',
            zIndex: theme.zIndex.drawer + 1
        }); },
        open: isLoaderOpen
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        color: "inherit"
    }))));
};
export default StandardJobsPartLabourDetailsDrawer;
